import { render, staticRenderFns } from "./SBPEmailDialog.vue?vue&type=template&id=ae81b2f8&"
import script from "./SBPEmailDialog.vue?vue&type=script&lang=js&"
export * from "./SBPEmailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports